import moment from 'moment-timezone-all'
import React from 'react'
import { connect } from 'react-redux'

import DatePicker from '../DatePicker'
import { doChangeTimeframe } from '../../actions'
import {
  selectToday,
  selectStartOfReports,
  selectTimeframeEnd,
  selectTimeframeStart,
  selectTimezone,
} from '../../selectors'

const select = state => ({
  endDate: selectTimeframeEnd(state).toDate(),
  today: selectToday(state),
  timezone: selectTimezone(state),
  startDate: selectTimeframeStart(state).toDate(),
  startOfReports: selectStartOfReports(state),
})
const perform = {
  onApply: doChangeTimeframe,
}

export default connect(select, perform)(DatePicker)
